module.exports = __webpack_public_path__ + "img/award-5.cd31bf11.png";